import { useEffect } from 'react';
import { AppHubStateType, type AppHubState } from 'src/services/AppHubService';
import { useApplicationClientContext } from 'src/state';

export function getAppHubStateDebugUrl(state?: AppHubState) {
  switch (state?.type) {
    case AppHubStateType.Login:
      return state.qr?.debugUrl;
    case AppHubStateType.Empty:
    case AppHubStateType.Pending:
      return state.debugUrl;
    default:
      return undefined;
  }
}

export function useSetDebugUrl(debugUrl?: string) {
  const [, dispatchClientContext] = useApplicationClientContext();
  useEffect(() => {
    if (!debugUrl) return;

    dispatchClientContext({ type: 'setDebugUrl', payload: { debugUrl } });

    return () => {
      dispatchClientContext({
        type: 'setDebugUrl',
        payload: { debugUrl: undefined },
      });
    };
  }, [debugUrl, dispatchClientContext]);
}

export function useDebugUrl(): string | undefined {
  const [clientContext] = useApplicationClientContext();

  return clientContext.debugUrl;
}
